module.exports = __webpack_public_path__ + "static/media/S+ Home Safety Checklist v4 (eng).d61fa35a.pdf";